// /** @format */

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import StatsContainer from "./StatsContainer";
import Avatar from "../../../components/common/Avatar";
import Notifications from "./Notifications";
import { rows } from "../../../utils/Data";
import HeaderWrapper from "../../../components/common/HeaderWrapper";
import CustomButton from "../../../components/common/CustomButton";
import Graph from "../../../components/Graph";
import Table from "../ApplicationsPage/AnalystApp/Table";
import { SearchIcon } from "../../../components/common/IconComponents";

const Dashboard = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchTerm(query);
  };

  const filteredRows = searchTerm
    ? rows.filter((row) => {
        const searchWords = searchTerm.toLowerCase().split(" ");
        const fullName = `${row.Name} ${row.Surname}`.toLowerCase();

        return searchWords.every((word) => fullName.includes(word));
      })
    : rows;

  const totalCount = rows.length;
  const defaultCount = rows.filter(
    (row) => row.Status.toLowerCase() === "disapproved"
  ).length;
  const pendingCount = rows.filter(
    (row) => row.Status.toLowerCase() === "pending"
  ).length;

  const handleProfileClick = (applicantId) => {
    // Redirect to the profile page with the applicant's ID
    navigate(`/profile/${applicantId}`);
  };

  return (
    <div className="">
      <HeaderWrapper>
        <div className="flex  flex-wrap w-full items-center justify-between -mt-1">
          <p className="">Hi Tofunmi</p>
          <div className="relative flex items-center">
            <SearchIcon
              className="w-3 h-5 absolute ml-3 pointer-events-none"
              icon={SearchIcon}
            />

            <input
              className="pr-3 pl-10 border-0 mr-2 bg-gray-50 w-full   rounded-3xl placeholder-p-2 md:w-96"
              type="text"
              id="name"
              autoComplete="off"
              placeholder="Search"
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </div>
          <div className="flex items-center">
            <span className="mr-6">
              <CustomButton
                className="xl:px-5 md:px-2 lg:px-3 xl:py-2"
                onClick={() => navigate("/CreateModelStep1")}
              >
                Create Model
              </CustomButton>
            </span>
            <span className="w-8 h-10 rounded-full ">
              <Avatar />
            </span>
          </div>
        </div>
      </HeaderWrapper>

      <div className="pt-2 mx-5">
        <div className="grid grid-cols-1 md:grid-cols-6 gap-3">
          <div className="md:col-span-4 gap-3">
            <StatsContainer
              totalCount={totalCount}
              defaultCount={defaultCount}
              pendingCount={pendingCount}
            />
            <Graph />
            <Table
              arrays={filteredRows}
              showActions={false}
              onProfileClick={handleProfileClick}
            />
          </div>
          <div className="md:col-span-2">
            <Notifications />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
